import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { summaryEnergy } from "../../../services/app";
import ItemEnergy from "../../../components/ItemEnergy/ItemTotal";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import { useWindowSize } from "../../../hook/useWindowSize";

export const TabEnergy = (props) => {
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const { T, setLoading, language } = useApp();
  const [dataTab, setDataTab] = useState([]);

  const loadData = async () => {
    setLoading(true);
    const result = await summaryEnergy();
    setDataTab(result?.data?.data || {});
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] mt-[10px]">
      <div className="flex justify-between items-start gap-[40px]">
        <div className={`flex-1 w-full`}>
          <ItemEnergy data={dataTab} />
        </div>
      </div>
    </div>
  );
};
